import { useState, useCallback } from 'react'

import { getLiveData } from '../api'

const usePreconnect = (liveId, liveToken, onError = () => {}) => {
  const [webinar, setWebinar] = useState(null)

  const load = useCallback(() => {
    const params = { include_speakers_p: 1 }
    getLiveData(liveId, liveToken, params)
      .then((response) => {
        setWebinar(response)
      })
      .catch((err) => {
        onError(err)
      })
  }, [liveId, liveToken, onError])

  return { load, webinar }
}

export default usePreconnect
